import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { eraseCookie } from '../../utils/cookies'

const Logout: FC = () => {
  const history = useHistory()

  // remove token
  eraseCookie('token')

  // redirect to home
  history.push('/')

  return <div></div>
}

export default Logout
